function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "undock",
  transform: "translate(-14.964 -16.26)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2148",
  "data-name": "Group 2148",
  transform: "translate(20.022 16.26)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2147",
  "data-name": "Group 2147"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1142",
  "data-name": "Path 1142",
  d: "M46.8,30.064h-9.86a1.286,1.286,0,0,1-1.284-1.284V18.544a1.286,1.286,0,0,1,1.284-1.284H46.8a1.285,1.285,0,0,1,1.284,1.284V28.78A1.285,1.285,0,0,1,46.8,30.064Zm-9.86-12.326a.807.807,0,0,0-.806.806V28.78a.807.807,0,0,0,.806.806H46.8a.807.807,0,0,0,.806-.806V18.544a.807.807,0,0,0-.806-.806Z",
  transform: "translate(-35.396 -17.003)",
  fill: "#47a9f8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1143",
  "data-name": "Path 1143",
  d: "M46.054,29.578h-9.86a1.542,1.542,0,0,1-1.541-1.541V17.8a1.543,1.543,0,0,1,1.541-1.541h9.86A1.542,1.542,0,0,1,47.6,17.8V28.037A1.542,1.542,0,0,1,46.054,29.578Zm-9.86-12.326a.55.55,0,0,0-.549.549V28.037a.55.55,0,0,0,.549.549h9.86a.55.55,0,0,0,.549-.549V17.8a.55.55,0,0,0-.549-.549Z",
  transform: "translate(-34.653 -16.26)",
  fill: "#47a9f8"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2150",
  "data-name": "Group 2150",
  transform: "translate(14.964 20.276)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2149",
  "data-name": "Group 2149",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1144",
  "data-name": "Path 1144",
  d: "M27.108,45.7h-9.86a1.285,1.285,0,0,1-1.284-1.284V34.178a1.285,1.285,0,0,1,1.284-1.284h3.066v.478H17.248a.807.807,0,0,0-.806.806V44.414a.807.807,0,0,0,.806.806h9.86a.807.807,0,0,0,.806-.806V42.259h.478v2.155A1.286,1.286,0,0,1,27.108,45.7Z",
  transform: "translate(-15.707 -32.637)",
  fill: "#47a9f8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1145",
  "data-name": "Path 1145",
  d: "M26.365,45.212H16.5a1.543,1.543,0,0,1-1.541-1.541V33.435A1.543,1.543,0,0,1,16.5,31.894h3.323v.992H16.5a.549.549,0,0,0-.549.549V43.671a.549.549,0,0,0,.549.549h9.861a.549.549,0,0,0,.548-.549V41.259h.992v2.412A1.543,1.543,0,0,1,26.365,45.212Z",
  transform: "translate(-14.964 -31.894)",
  fill: "#47a9f8"
}))));

function SvgUndock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.334,
    viewBox: "0 0 18 17.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndock);
export default __webpack_public_path__ + "static/media/undock.0c380367.svg";
export { ForwardRef as ReactComponent };